const ElectricityProfilesConfig = {
  collection: "electricity_profiles",
  fields: [
    "id",
    "date_updated",
    "date_created",
    "locale.id",
    "locale.name",
    "state_province",
    "average_retail_price_cents_kwh",
    "average_retail_price_dollar_kwh",
    "net_summer_capacity_mw",
    "net_generation_mwh"
  ],

  adapter: class ElectricityProfile {
    constructor(electricityProfile) {
      Object.assign(this, {
        ...electricityProfile,
        average_retail_price_cents_kwh: Number.parseFloat(
          electricityProfile.average_retail_price_cents_kwh || 0
        ),
        average_retail_price_dollar_kwh: Number.parseFloat(
          electricityProfile.average_retail_price_dollar_kwh || 0
        ),
        net_summer_capacity_mw: Number.parseFloat(
          electricityProfile.net_summer_capacity_mw || 0
        ),
        net_generation_mwh: Number.parseFloat(
          electricityProfile.net_generation_mwh || 0
        ),
        date_updated:
          electricityProfile.date_updated || electricityProfile.date_created
      });
    }
  }
};

export default ElectricityProfilesConfig;
